<template>
  <Card variant="tertiary" size="medium">
    <View gap="sm" justify="space-between">
      <Avatar :user-name="renterName" status="pending" />

      <View gap="sm" direction="row" justify="space-between" wrap="wrap" :grow="1">
        <div class="request-info">
          <Text variant="h5">{{ renterName }}</Text>
          <Text variant="body-small" color="secondary">
            <span>requested for showing&nbsp;</span>
            <Text as="span" variant="body-small" color="tertiary">{{ requestedTimeAgo }}</Text>
          </Text>
        </div>

        <Button class="review-button" size="medium" :to="renterProfileRoute(propertyId, renterId)">Review</Button>
      </View>
    </View>
  </Card>
</template>

<script setup lang="ts">
import { useTimeAgo } from '@vueuse/core';

import { Button, Card, Text, Avatar, View } from '@tallo/design-system';
import { renterProfileRoute } from '@tallo/investor/navigation';
import { useTimeAgoShortMessages } from '@tallo/utility';

const props = defineProps<{ renterName: string; renterId: string; propertyId: string; requestedAt: string }>();
const requestedTimeAgo = useTimeAgo(props.requestedAt, { messages: useTimeAgoShortMessages });
</script>

<style scoped lang="scss">
.request-info {
  flex-grow: 1;
}

.review-button {
  flex: 1;
}
</style>
